import { keyBy } from 'lodash';
import { EntityAction } from '../../types';
import { ClassroomActionType } from './types';

const defaultState = {
  classrooms: [],
  classroomsById: {},
  students: [],
  studentsById: {}
};

const classroomsReducer = (state = defaultState as any, action: EntityAction) => {
  switch (action.type) {
    case ClassroomActionType.CLASSROOMS_REQUEST_SUCCESS: {
      const { classrooms, students } = action.data.classrooms.reduce(
        (acc, classroom) => {
          const { students, ...rest } = classroom;
          // TODO: Should probably include only 'studentIds' in the classroom since student objects
          // are now getting pulled off and stored in state separately, but need to check other areas
          // where classrooms state is being used first.
          acc.classrooms.push({
            ...rest,
            students,
            studentIds: students.map(student => student.id)
          });
          acc.students = acc.students.concat(students);

          return acc;
        },
        { classrooms: [], students: [] }
      );

      return {
        ...state,
        classrooms,
        classroomsById: keyBy(classrooms, 'id'),
        students,
        studentsById: keyBy(students, 'id')
      };
    }
    default:
      return state;
  }
};

export default classroomsReducer;
